var _filter, _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7, _use, _use2, _use3, _use4, _use5, _use6, _use7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrape(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "71px",
    height: "72px",
    viewBox: "0 0 71 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "alpha",
    filterUnits: "objectBoundingBox",
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    in: "SourceGraphic",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 71,
    height: 72,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.980392,
      stroke: "none"
    }
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 71,
    height: 72
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface5",
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 53.730469 20.417969 C 53.730469 18.871094 53.730469 17.320312 53.730469 15.773438 C 54.503906 15.789062 55.269531 15.773438 56.027344 15.726562 C 56.027344 13.394531 56.027344 11.066406 56.027344 8.738281 C 55.246094 8.738281 54.464844 8.738281 53.679688 8.738281 C 53.679688 11.066406 53.679688 13.394531 53.679688 15.726562 C 52.914062 15.726562 52.148438 15.726562 51.382812 15.726562 C 51.367188 15.726562 51.347656 15.726562 51.332031 15.726562 C 51.332031 13.378906 51.332031 11.035156 51.332031 8.6875 C 52.117188 8.6875 52.898438 8.6875 53.679688 8.6875 C 53.679688 7.921875 53.679688 7.15625 53.679688 6.390625 C 54.480469 6.390625 55.277344 6.390625 56.078125 6.390625 C 56.078125 7.15625 56.078125 7.921875 56.078125 8.6875 C 56.84375 8.6875 57.609375 8.6875 58.375 8.6875 C 58.375 11.050781 58.375 13.414062 58.375 15.773438 C 57.609375 15.773438 56.84375 15.773438 56.078125 15.773438 C 56.078125 17.320312 56.078125 18.871094 56.078125 20.417969 C 55.292969 20.417969 54.511719 20.417969 53.730469 20.417969 Z M 53.730469 20.417969 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 71,
    height: 72,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.984314,
      stroke: "none"
    }
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 71,
    height: 72
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface8",
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 39.738281 15.726562 C 36.625 15.726562 33.511719 15.726562 30.398438 15.726562 C 30.382812 15.726562 30.367188 15.726562 30.351562 15.726562 C 30.351562 14.945312 30.351562 14.164062 30.351562 13.378906 C 33.480469 13.378906 36.609375 13.378906 39.738281 13.378906 C 39.738281 14.164062 39.738281 14.945312 39.738281 15.726562 Z M 39.738281 15.726562 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 71,
    height: 72,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.996078,
      stroke: "none"
    }
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 71,
    height: 72
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface11",
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 39.738281 15.726562 C 42.070312 15.726562 44.402344 15.726562 46.734375 15.726562 C 46.734375 16.492188 46.734375 17.257812 46.734375 18.023438 C 44.402344 18.023438 42.070312 18.023438 39.738281 18.023438 C 39.738281 17.257812 39.738281 16.492188 39.738281 15.726562 Z M 39.738281 15.726562 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 71,
    height: 72,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.984314,
      stroke: "none"
    }
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 71,
    height: 72
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface14",
    clipPath: "url(#clip4)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 51.332031 15.726562 C 51.332031 16.492188 51.332031 17.257812 51.332031 18.023438 C 50.558594 18.007812 49.792969 18.023438 49.035156 18.070312 C 49.035156 18.085938 49.035156 18.105469 49.035156 18.121094 C 49.035156 18.871094 49.035156 19.621094 49.035156 20.371094 C 48.265625 20.371094 47.5 20.371094 46.734375 20.371094 C 46.734375 19.585938 46.734375 18.804688 46.734375 18.023438 C 47.484375 18.023438 48.234375 18.023438 48.984375 18.023438 C 48.984375 17.257812 48.984375 16.492188 48.984375 15.726562 C 49.769531 15.726562 50.550781 15.726562 51.332031 15.726562 Z M 51.332031 15.726562 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 71,
    height: 72,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.992157,
      stroke: "none"
    }
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 71,
    height: 72
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface17",
    clipPath: "url(#clip5)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 51.382812 20.417969 C 52.148438 20.417969 52.914062 20.417969 53.679688 20.417969 C 53.695312 20.417969 53.714844 20.417969 53.730469 20.417969 C 53.730469 21.199219 53.730469 21.980469 53.730469 22.761719 C 52.960938 22.761719 52.195312 22.761719 51.429688 22.761719 C 51.429688 26.609375 51.429688 30.453125 51.429688 34.300781 C 52.195312 34.300781 52.960938 34.300781 53.730469 34.300781 C 53.730469 35.082031 53.730469 35.863281 53.730469 36.644531 C 54.511719 36.644531 55.292969 36.644531 56.078125 36.644531 C 56.078125 39.007812 56.078125 41.371094 56.078125 43.730469 C 55.292969 43.730469 54.511719 43.730469 53.730469 43.730469 C 53.730469 44.511719 53.730469 45.296875 53.730469 46.078125 C 52.960938 46.078125 52.195312 46.078125 51.429688 46.078125 C 51.429688 46.84375 51.429688 47.609375 51.429688 48.375 C 49.863281 48.375 48.300781 48.375 46.734375 48.375 C 46.734375 49.15625 46.734375 49.9375 46.734375 50.722656 C 45.953125 50.722656 45.167969 50.722656 44.386719 50.722656 C 44.386719 51.488281 44.386719 52.253906 44.386719 53.019531 C 43.621094 53.019531 42.855469 53.019531 42.085938 53.019531 C 42.085938 53.785156 42.085938 54.550781 42.085938 55.316406 C 40.539062 55.316406 38.988281 55.316406 37.441406 55.316406 C 37.441406 56.097656 37.441406 56.878906 37.441406 57.664062 C 36.65625 57.664062 35.875 57.664062 35.09375 57.664062 C 35.09375 56.113281 35.09375 54.566406 35.09375 53.019531 C 37.417969 53.035156 39.730469 53.019531 42.039062 52.972656 C 42.039062 52.203125 42.039062 51.4375 42.039062 50.671875 C 42.820312 50.671875 43.605469 50.671875 44.386719 50.671875 C 44.386719 48.34375 44.386719 46.011719 44.386719 43.683594 C 45.152344 43.683594 45.921875 43.683594 46.6875 43.683594 C 46.671875 44.457031 46.6875 45.222656 46.734375 45.980469 C 48.273438 46.027344 49.824219 46.046875 51.382812 46.027344 C 51.382812 45.246094 51.382812 44.464844 51.382812 43.683594 C 52.148438 43.683594 52.914062 43.683594 53.679688 43.683594 C 53.679688 41.355469 53.679688 39.023438 53.679688 36.695312 C 52.914062 36.695312 52.148438 36.695312 51.382812 36.695312 C 51.382812 35.914062 51.382812 35.128906 51.382812 34.347656 C 49.042969 34.332031 46.710938 34.347656 44.386719 34.394531 C 44.386719 35.164062 44.386719 35.929688 44.386719 36.695312 C 43.605469 36.695312 42.820312 36.695312 42.039062 36.695312 C 42.039062 38.242188 42.039062 39.789062 42.039062 41.335938 C 39.707031 41.335938 37.375 41.335938 35.042969 41.335938 C 35.042969 42.121094 35.042969 42.902344 35.042969 43.683594 C 34.277344 43.683594 33.511719 43.683594 32.746094 43.683594 C 32.699219 45.988281 32.679688 48.304688 32.699219 50.625 C 31.929688 50.625 31.164062 50.625 30.398438 50.625 C 30.398438 49.078125 30.398438 47.527344 30.398438 45.980469 C 29.617188 45.980469 28.832031 45.980469 28.050781 45.980469 C 28.050781 45.214844 28.050781 44.449219 28.050781 43.683594 C 28.832031 43.683594 29.617188 43.683594 30.398438 43.683594 C 30.398438 41.355469 30.398438 39.023438 30.398438 36.695312 C 32.730469 36.695312 35.0625 36.695312 37.390625 36.695312 C 38.160156 36.695312 38.925781 36.695312 39.691406 36.695312 C 39.738281 35.9375 39.753906 35.171875 39.738281 34.394531 C 40.515625 34.410156 41.28125 34.394531 42.039062 34.347656 C 42.039062 32.019531 42.039062 29.6875 42.039062 27.359375 C 42.054688 27.359375 42.070312 27.359375 42.085938 27.359375 C 42.828125 27.40625 43.582031 27.421875 44.339844 27.40625 C 44.324219 28.945312 44.339844 30.480469 44.386719 32.003906 C 45.929688 32.050781 47.476562 32.066406 49.035156 32.050781 C 49.035156 28.9375 49.035156 25.828125 49.035156 22.714844 C 49.816406 22.714844 50.597656 22.714844 51.382812 22.714844 C 51.382812 21.949219 51.382812 21.183594 51.382812 20.417969 Z M 51.382812 20.417969 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 71,
    height: 72,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.976471,
      stroke: "none"
    }
  }))), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 71,
    height: 72
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface20",
    clipPath: "url(#clip6)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 30.351562 15.726562 C 30.351562 16.492188 30.351562 17.257812 30.351562 18.023438 C 29.589844 18.007812 28.839844 18.023438 28.097656 18.070312 C 28.050781 18.828125 28.035156 19.59375 28.050781 20.371094 C 25.71875 20.371094 23.386719 20.371094 21.054688 20.371094 C 21.054688 21.152344 21.054688 21.933594 21.054688 22.714844 C 20.289062 22.714844 19.523438 22.714844 18.757812 22.714844 C 18.757812 25.046875 18.757812 27.375 18.757812 29.703125 C 19.523438 29.703125 20.289062 29.703125 21.054688 29.703125 C 21.054688 30.488281 21.054688 31.269531 21.054688 32.050781 C 23.394531 32.066406 25.726562 32.050781 28.050781 32.003906 C 28.097656 30.480469 28.113281 28.945312 28.097656 27.40625 C 28.847656 27.40625 29.597656 27.40625 30.351562 27.40625 C 30.351562 30.488281 30.351562 33.566406 30.351562 36.644531 C 29.597656 36.644531 28.847656 36.644531 28.097656 36.644531 C 28.113281 35.871094 28.097656 35.105469 28.050781 34.347656 C 25.71875 34.347656 23.386719 34.347656 21.054688 34.347656 C 21.054688 35.128906 21.054688 35.914062 21.054688 36.695312 C 20.289062 36.695312 19.523438 36.695312 18.757812 36.695312 C 18.757812 39.023438 18.757812 41.355469 18.757812 43.683594 C 19.523438 43.683594 20.289062 43.683594 21.054688 43.683594 C 21.054688 44.464844 21.054688 45.246094 21.054688 46.027344 C 23.386719 46.027344 25.71875 46.027344 28.050781 46.027344 C 28.050781 46.796875 28.050781 47.5625 28.050781 48.328125 C 27.273438 48.3125 26.507812 48.328125 25.75 48.375 C 25.703125 49.117188 25.6875 49.867188 25.703125 50.625 C 24.929688 50.609375 24.160156 50.625 23.402344 50.671875 C 23.402344 53.003906 23.402344 55.332031 23.402344 57.664062 C 24.167969 57.664062 24.9375 57.664062 25.703125 57.664062 C 25.6875 58.4375 25.703125 59.203125 25.75 59.960938 C 28.074219 60.007812 30.40625 60.023438 32.746094 60.007812 C 32.746094 60.789062 32.746094 61.570312 32.746094 62.355469 C 30.398438 62.355469 28.050781 62.355469 25.703125 62.355469 C 25.703125 61.570312 25.703125 60.789062 25.703125 60.007812 C 24.921875 60.007812 24.136719 60.007812 23.355469 60.007812 C 23.355469 59.226562 23.355469 58.445312 23.355469 57.664062 C 22.589844 57.664062 21.820312 57.664062 21.054688 57.664062 C 21.054688 55.316406 21.054688 52.972656 21.054688 50.625 C 21.820312 50.625 22.589844 50.625 23.355469 50.625 C 23.355469 49.875 23.355469 49.125 23.355469 48.375 C 22.589844 48.375 21.820312 48.375 21.054688 48.375 C 21.054688 47.609375 21.054688 46.84375 21.054688 46.078125 C 20.257812 46.078125 19.457031 46.078125 18.660156 46.078125 C 18.660156 45.296875 18.660156 44.511719 18.660156 43.730469 C 17.894531 43.730469 17.128906 43.730469 16.359375 43.730469 C 16.359375 41.371094 16.359375 39.007812 16.359375 36.644531 C 17.128906 36.644531 17.894531 36.644531 18.660156 36.644531 C 18.660156 35.863281 18.660156 35.082031 18.660156 34.300781 C 19.457031 34.300781 20.257812 34.300781 21.054688 34.300781 C 21.054688 33.566406 21.054688 32.832031 21.054688 32.097656 C 20.257812 32.097656 19.457031 32.097656 18.660156 32.097656 C 18.660156 31.316406 18.660156 30.535156 18.660156 29.753906 C 17.894531 29.753906 17.128906 29.753906 16.359375 29.753906 C 16.359375 27.390625 16.359375 25.027344 16.359375 22.667969 C 17.128906 22.667969 17.894531 22.667969 18.660156 22.667969 C 18.660156 21.886719 18.660156 21.105469 18.660156 20.320312 C 19.457031 20.320312 20.257812 20.320312 21.054688 20.320312 C 21.054688 19.554688 21.054688 18.789062 21.054688 18.023438 C 23.371094 18.023438 25.6875 18.023438 28.003906 18.023438 C 28.003906 17.257812 28.003906 16.492188 28.003906 15.726562 C 28.785156 15.726562 29.566406 15.726562 30.351562 15.726562 Z M 30.351562 15.726562 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 71,
    height: 72,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.968627,
      stroke: "none"
    }
  }))), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 71,
    height: 72
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface23",
    clipPath: "url(#clip7)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 32.746094 57.664062 C 33.527344 57.664062 34.308594 57.664062 35.09375 57.664062 C 35.09375 58.445312 35.09375 59.226562 35.09375 60.007812 C 34.308594 60.007812 33.527344 60.007812 32.746094 60.007812 C 32.746094 59.226562 32.746094 58.445312 32.746094 57.664062 Z M 32.746094 57.664062 "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface5",
    mask: "url(#mask0)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,40.392157%,5.882353%)",
      fillOpacity: 1
    },
    d: "M 56.027344 15.726562 C 56.011719 15.726562 55.996094 15.726562 55.980469 15.726562 C 55.980469 13.414062 55.980469 11.097656 55.980469 8.785156 C 55.230469 8.785156 54.480469 8.785156 53.730469 8.785156 C 53.730469 11.097656 53.730469 13.414062 53.730469 15.726562 C 53.714844 15.726562 53.695312 15.726562 53.679688 15.726562 C 53.679688 13.394531 53.679688 11.066406 53.679688 8.738281 C 54.464844 8.738281 55.246094 8.738281 56.027344 8.738281 C 56.027344 11.066406 56.027344 13.394531 56.027344 15.726562 Z M 56.027344 15.726562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,57.254902%,9.803922%)",
      fillOpacity: 1
    },
    d: "M 55.980469 15.726562 C 55.230469 15.726562 54.480469 15.726562 53.730469 15.726562 C 53.730469 13.414062 53.730469 11.097656 53.730469 8.785156 C 54.480469 8.785156 55.230469 8.785156 55.980469 8.785156 C 55.980469 11.097656 55.980469 13.414062 55.980469 15.726562 Z M 55.980469 15.726562 "
  }), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface8",
    mask: "url(#mask1)"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface11",
    mask: "url(#mask2)"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface14",
    mask: "url(#mask3)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,56.862745%,9.803922%)",
      fillOpacity: 1
    },
    d: "M 30.398438 15.726562 C 33.511719 15.726562 36.625 15.726562 39.738281 15.726562 C 39.738281 16.492188 39.738281 17.257812 39.738281 18.023438 C 39.738281 18.039062 39.738281 18.054688 39.738281 18.070312 C 39.691406 17.3125 39.675781 16.546875 39.691406 15.773438 C 38.144531 15.773438 36.59375 15.773438 35.042969 15.773438 C 35.042969 16.539062 35.042969 17.304688 35.042969 18.070312 C 35.804688 18.121094 36.570312 18.136719 37.34375 18.121094 C 37.34375 18.886719 37.34375 19.652344 37.34375 20.417969 C 39.691406 20.417969 42.039062 20.417969 44.386719 20.417969 C 44.386719 22.730469 44.386719 25.046875 44.386719 27.359375 C 43.621094 27.359375 42.855469 27.359375 42.085938 27.359375 C 42.070312 27.359375 42.054688 27.359375 42.039062 27.359375 C 42.039062 26.59375 42.039062 25.828125 42.039062 25.0625 C 41.28125 25.011719 40.515625 24.996094 39.738281 25.011719 C 39.753906 24.238281 39.738281 23.472656 39.691406 22.714844 C 36.59375 22.714844 33.496094 22.714844 30.398438 22.714844 C 30.398438 21.949219 30.398438 21.183594 30.398438 20.417969 C 29.640625 20.371094 28.875 20.355469 28.097656 20.371094 C 28.097656 19.621094 28.097656 18.871094 28.097656 18.121094 C 28.875 18.136719 29.640625 18.121094 30.398438 18.070312 C 30.398438 17.289062 30.398438 16.507812 30.398438 15.726562 Z M 30.398438 15.726562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,69.803922%,12.54902%)",
      fillOpacity: 1
    },
    d: "M 39.738281 18.070312 C 42.054688 18.070312 44.371094 18.070312 46.6875 18.070312 C 46.6875 18.855469 46.6875 19.636719 46.6875 20.417969 C 47.476562 20.433594 48.261719 20.417969 49.035156 20.371094 C 49.035156 19.621094 49.035156 18.871094 49.035156 18.121094 C 49.816406 18.121094 50.597656 18.121094 51.382812 18.121094 C 51.382812 18.886719 51.382812 19.652344 51.382812 20.417969 C 51.332031 21.160156 51.316406 21.910156 51.332031 22.667969 C 50.558594 22.652344 49.792969 22.667969 49.035156 22.714844 C 49.035156 25.828125 49.035156 28.9375 49.035156 32.050781 C 47.476562 32.066406 45.929688 32.050781 44.386719 32.003906 C 44.386719 30.453125 44.386719 28.90625 44.386719 27.359375 C 44.386719 25.046875 44.386719 22.730469 44.386719 20.417969 C 42.0625 20.371094 39.730469 20.355469 37.390625 20.371094 C 37.390625 19.605469 37.390625 18.835938 37.390625 18.070312 C 36.609375 18.070312 35.828125 18.070312 35.042969 18.070312 C 35.042969 17.304688 35.042969 16.539062 35.042969 15.773438 C 36.59375 15.773438 38.144531 15.773438 39.691406 15.773438 C 39.675781 16.546875 39.691406 17.3125 39.738281 18.070312 Z M 39.738281 18.070312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,56.470588%,9.803922%)",
      fillOpacity: 1
    },
    d: "M 51.382812 15.726562 C 52.148438 15.726562 52.914062 15.726562 53.679688 15.726562 C 53.679688 17.289062 53.679688 18.855469 53.679688 20.417969 C 52.914062 20.417969 52.148438 20.417969 51.382812 20.417969 C 51.382812 19.652344 51.382812 18.886719 51.382812 18.121094 C 50.597656 18.121094 49.816406 18.121094 49.035156 18.121094 C 49.035156 18.105469 49.035156 18.085938 49.035156 18.070312 C 49.816406 18.070312 50.597656 18.070312 51.382812 18.070312 C 51.382812 17.289062 51.382812 16.507812 51.382812 15.726562 Z M 51.382812 15.726562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,12.156863%,1.176471%)",
      fillOpacity: 1
    },
    d: "M 53.679688 15.726562 C 53.695312 15.726562 53.714844 15.726562 53.730469 15.726562 C 54.480469 15.726562 55.230469 15.726562 55.980469 15.726562 C 55.996094 15.726562 56.011719 15.726562 56.027344 15.726562 C 55.269531 15.773438 54.503906 15.789062 53.730469 15.773438 C 53.730469 17.320312 53.730469 18.871094 53.730469 20.417969 C 53.714844 20.417969 53.695312 20.417969 53.679688 20.417969 C 53.679688 18.855469 53.679688 17.289062 53.679688 15.726562 Z M 53.679688 15.726562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,12.156863%,1.176471%)",
      fillOpacity: 1
    },
    d: "M 30.351562 15.726562 C 30.367188 15.726562 30.382812 15.726562 30.398438 15.726562 C 30.398438 16.507812 30.398438 17.289062 30.398438 18.070312 C 29.632812 18.070312 28.863281 18.070312 28.097656 18.070312 C 28.839844 18.023438 29.589844 18.007812 30.351562 18.023438 C 30.351562 17.257812 30.351562 16.492188 30.351562 15.726562 Z M 30.351562 15.726562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,17.254902%,1.176471%)",
      fillOpacity: 1
    },
    d: "M 51.332031 15.726562 C 51.347656 15.726562 51.367188 15.726562 51.382812 15.726562 C 51.382812 16.507812 51.382812 17.289062 51.382812 18.070312 C 50.597656 18.070312 49.816406 18.070312 49.035156 18.070312 C 49.792969 18.023438 50.558594 18.007812 51.332031 18.023438 C 51.332031 17.257812 51.332031 16.492188 51.332031 15.726562 Z M 51.332031 15.726562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,36.078431%,5.098039%)",
      fillOpacity: 1
    },
    d: "M 28.097656 18.070312 C 28.863281 18.070312 29.632812 18.070312 30.398438 18.070312 C 29.640625 18.121094 28.875 18.136719 28.097656 18.121094 C 28.097656 18.871094 28.097656 19.621094 28.097656 20.371094 C 28.875 20.355469 29.640625 20.371094 30.398438 20.417969 C 29.632812 20.417969 28.863281 20.417969 28.097656 20.417969 C 28.082031 20.417969 28.066406 20.417969 28.050781 20.417969 C 28.050781 20.402344 28.050781 20.386719 28.050781 20.371094 C 28.035156 19.59375 28.050781 18.828125 28.097656 18.070312 Z M 28.097656 18.070312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(30.588235%,0.784314%,26.27451%)",
      fillOpacity: 1
    },
    d: "M 28.050781 20.371094 C 28.050781 20.386719 28.050781 20.402344 28.050781 20.417969 C 25.734375 20.417969 23.417969 20.417969 21.105469 20.417969 C 21.105469 21.183594 21.105469 21.949219 21.105469 22.714844 C 21.085938 22.714844 21.070312 22.714844 21.054688 22.714844 C 21.054688 21.933594 21.054688 21.152344 21.054688 20.371094 C 23.386719 20.371094 25.71875 20.371094 28.050781 20.371094 Z M 28.050781 20.371094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,63.921569%,11.372549%)",
      fillOpacity: 1
    },
    d: "M 35.042969 18.070312 C 35.828125 18.070312 36.609375 18.070312 37.390625 18.070312 C 37.390625 18.835938 37.390625 19.605469 37.390625 20.371094 C 39.730469 20.355469 42.0625 20.371094 44.386719 20.417969 C 42.039062 20.417969 39.691406 20.417969 37.34375 20.417969 C 37.34375 19.652344 37.34375 18.886719 37.34375 18.121094 C 36.570312 18.136719 35.804688 18.121094 35.042969 18.070312 Z M 35.042969 18.070312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,25.490196%,3.529412%)",
      fillOpacity: 1
    },
    d: "M 39.738281 18.070312 C 39.738281 18.054688 39.738281 18.039062 39.738281 18.023438 C 42.070312 18.023438 44.402344 18.023438 46.734375 18.023438 C 46.734375 18.804688 46.734375 19.585938 46.734375 20.371094 C 47.5 20.371094 48.265625 20.371094 49.035156 20.371094 C 48.261719 20.417969 47.476562 20.433594 46.6875 20.417969 C 46.6875 19.636719 46.6875 18.855469 46.6875 18.070312 C 44.371094 18.070312 42.054688 18.070312 39.738281 18.070312 Z M 39.738281 18.070312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(67.45098%,1.176471%,58.823529%)",
      fillOpacity: 1
    },
    d: "M 28.050781 20.417969 C 28.050781 21.199219 28.050781 21.980469 28.050781 22.761719 C 28.816406 22.761719 29.582031 22.761719 30.351562 22.761719 C 30.351562 24.296875 30.351562 25.828125 30.351562 27.359375 C 29.582031 27.359375 28.816406 27.359375 28.050781 27.359375 C 28.050781 28.140625 28.050781 28.921875 28.050781 29.703125 C 27.285156 29.703125 26.515625 29.703125 25.75 29.703125 C 25.75 28.921875 25.75 28.140625 25.75 27.359375 C 24.203125 27.359375 22.652344 27.359375 21.105469 27.359375 C 21.105469 25.8125 21.105469 24.261719 21.105469 22.714844 C 21.105469 21.949219 21.105469 21.183594 21.105469 20.417969 C 23.417969 20.417969 25.734375 20.417969 28.050781 20.417969 Z M 28.050781 20.417969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 28.097656 20.417969 C 28.863281 20.417969 29.632812 20.417969 30.398438 20.417969 C 30.398438 21.183594 30.398438 21.949219 30.398438 22.714844 C 29.632812 22.714844 28.863281 22.714844 28.097656 22.714844 C 28.097656 21.949219 28.097656 21.183594 28.097656 20.417969 Z M 28.097656 20.417969 "
  }), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface17",
    mask: "url(#mask4)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,52.54902%,8.235294%)",
      fillOpacity: 1
    },
    d: "M 51.382812 20.417969 C 51.382812 21.183594 51.382812 21.949219 51.382812 22.714844 C 50.597656 22.714844 49.816406 22.714844 49.035156 22.714844 C 49.792969 22.667969 50.558594 22.652344 51.332031 22.667969 C 51.316406 21.910156 51.332031 21.160156 51.382812 20.417969 Z M 51.382812 20.417969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(52.156863%,0.392157%,43.529412%)",
      fillOpacity: 1
    },
    d: "M 21.054688 22.714844 C 21.054688 24.277344 21.054688 25.84375 21.054688 27.40625 C 22.605469 27.40625 24.152344 27.40625 25.703125 27.40625 C 25.6875 28.179688 25.703125 28.945312 25.75 29.703125 C 26.515625 29.703125 27.285156 29.703125 28.050781 29.703125 C 28.050781 30.472656 28.050781 31.238281 28.050781 32.003906 C 25.734375 32.003906 23.417969 32.003906 21.105469 32.003906 C 21.121094 31.226562 21.101562 30.460938 21.054688 29.703125 C 20.289062 29.703125 19.523438 29.703125 18.757812 29.703125 C 18.757812 27.375 18.757812 25.046875 18.757812 22.714844 C 19.523438 22.714844 20.289062 22.714844 21.054688 22.714844 Z M 21.054688 22.714844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(45.882353%,0.784314%,40%)",
      fillOpacity: 1
    },
    d: "M 28.050781 20.417969 C 28.066406 20.417969 28.082031 20.417969 28.097656 20.417969 C 28.097656 21.183594 28.097656 21.949219 28.097656 22.714844 C 28.863281 22.714844 29.632812 22.714844 30.398438 22.714844 C 30.398438 24.261719 30.398438 25.8125 30.398438 27.359375 C 30.382812 27.359375 30.367188 27.359375 30.351562 27.359375 C 30.351562 25.828125 30.351562 24.296875 30.351562 22.761719 C 29.582031 22.761719 28.816406 22.761719 28.050781 22.761719 C 28.050781 21.980469 28.050781 21.199219 28.050781 20.417969 Z M 28.050781 20.417969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 30.398438 22.714844 C 33.496094 22.714844 36.59375 22.714844 39.691406 22.714844 C 39.691406 23.496094 39.691406 24.277344 39.691406 25.0625 C 37.375 25.0625 35.0625 25.0625 32.746094 25.0625 C 32.699219 25.820312 32.679688 26.585938 32.699219 27.359375 C 31.929688 27.359375 31.164062 27.359375 30.398438 27.359375 C 30.398438 25.8125 30.398438 24.261719 30.398438 22.714844 Z M 30.398438 22.714844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,37.647059%,5.490196%)",
      fillOpacity: 1
    },
    d: "M 39.691406 22.714844 C 39.738281 23.472656 39.753906 24.238281 39.738281 25.011719 C 40.515625 24.996094 41.28125 25.011719 42.039062 25.0625 C 41.273438 25.0625 40.507812 25.0625 39.738281 25.0625 C 39.722656 25.0625 39.707031 25.0625 39.691406 25.0625 C 39.691406 24.277344 39.691406 23.496094 39.691406 22.714844 Z M 39.691406 22.714844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(67.45098%,1.176471%,58.823529%)",
      fillOpacity: 1
    },
    d: "M 32.746094 25.0625 C 35.0625 25.0625 37.375 25.0625 39.691406 25.0625 C 39.707031 25.0625 39.722656 25.0625 39.738281 25.0625 C 39.738281 25.828125 39.738281 26.59375 39.738281 27.359375 C 40.480469 27.40625 41.234375 27.421875 41.992188 27.40625 C 41.992188 28.953125 41.992188 30.503906 41.992188 32.050781 C 41.226562 32.050781 40.457031 32.050781 39.691406 32.050781 C 39.691406 32.816406 39.691406 33.582031 39.691406 34.347656 C 39.691406 35.128906 39.691406 35.914062 39.691406 36.695312 C 38.925781 36.695312 38.160156 36.695312 37.390625 36.695312 C 37.390625 36.679688 37.390625 36.664062 37.390625 36.644531 C 37.390625 34.332031 37.390625 32.019531 37.390625 29.703125 C 36.609375 29.703125 35.828125 29.703125 35.042969 29.703125 C 35.042969 28.921875 35.042969 28.140625 35.042969 27.359375 C 34.277344 27.359375 33.511719 27.359375 32.746094 27.359375 C 32.746094 26.59375 32.746094 25.828125 32.746094 25.0625 Z M 32.746094 25.0625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 39.738281 25.0625 C 40.507812 25.0625 41.273438 25.0625 42.039062 25.0625 C 42.039062 25.828125 42.039062 26.59375 42.039062 27.359375 C 41.273438 27.359375 40.507812 27.359375 39.738281 27.359375 C 39.738281 26.59375 39.738281 25.828125 39.738281 25.0625 Z M 39.738281 25.0625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(57.647059%,0.784314%,49.411765%)",
      fillOpacity: 1
    },
    d: "M 21.054688 22.714844 C 21.070312 22.714844 21.085938 22.714844 21.105469 22.714844 C 21.105469 24.261719 21.105469 25.8125 21.105469 27.359375 C 22.652344 27.359375 24.203125 27.359375 25.75 27.359375 C 25.75 28.140625 25.75 28.921875 25.75 29.703125 C 25.703125 28.945312 25.6875 28.179688 25.703125 27.40625 C 24.152344 27.40625 22.605469 27.40625 21.054688 27.40625 C 21.054688 25.84375 21.054688 24.277344 21.054688 22.714844 Z M 21.054688 22.714844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(14.117647%,1.176471%,11.372549%)",
      fillOpacity: 1
    },
    d: "M 30.351562 27.359375 C 30.367188 27.359375 30.382812 27.359375 30.398438 27.359375 C 30.398438 30.472656 30.398438 33.582031 30.398438 36.695312 C 29.617188 36.695312 28.832031 36.695312 28.050781 36.695312 C 28.050781 35.929688 28.050781 35.164062 28.050781 34.394531 C 28.050781 34.378906 28.050781 34.363281 28.050781 34.347656 C 28.097656 35.105469 28.113281 35.871094 28.097656 36.644531 C 28.847656 36.644531 29.597656 36.644531 30.351562 36.644531 C 30.351562 33.566406 30.351562 30.488281 30.351562 27.40625 C 29.597656 27.40625 28.847656 27.40625 28.097656 27.40625 C 28.113281 28.945312 28.097656 30.480469 28.050781 32.003906 C 28.050781 31.238281 28.050781 30.472656 28.050781 29.703125 C 28.050781 28.921875 28.050781 28.140625 28.050781 27.359375 C 28.816406 27.359375 29.582031 27.359375 30.351562 27.359375 Z M 30.351562 27.359375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(52.156863%,0.392157%,43.529412%)",
      fillOpacity: 1
    },
    d: "M 32.746094 25.0625 C 32.746094 25.828125 32.746094 26.59375 32.746094 27.359375 C 33.511719 27.359375 34.277344 27.359375 35.042969 27.359375 C 35.042969 28.140625 35.042969 28.921875 35.042969 29.703125 C 35.804688 29.753906 36.570312 29.769531 37.34375 29.753906 C 37.328125 32.058594 37.34375 34.355469 37.390625 36.644531 C 37.390625 36.664062 37.390625 36.679688 37.390625 36.695312 C 35.0625 36.695312 32.730469 36.695312 30.398438 36.695312 C 30.398438 33.582031 30.398438 30.472656 30.398438 27.359375 C 31.164062 27.359375 31.929688 27.359375 32.699219 27.359375 C 32.679688 26.585938 32.699219 25.820312 32.746094 25.0625 Z M 32.746094 25.0625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,14.901961%,1.176471%)",
      fillOpacity: 1
    },
    d: "M 42.085938 27.359375 C 42.855469 27.359375 43.621094 27.359375 44.386719 27.359375 C 44.386719 28.90625 44.386719 30.453125 44.386719 32.003906 C 44.339844 30.480469 44.324219 28.945312 44.339844 27.40625 C 43.582031 27.421875 42.828125 27.40625 42.085938 27.359375 Z M 42.085938 27.359375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(57.647059%,0.784314%,49.019608%)",
      fillOpacity: 1
    },
    d: "M 35.042969 29.703125 C 35.828125 29.703125 36.609375 29.703125 37.390625 29.703125 C 37.390625 32.019531 37.390625 34.332031 37.390625 36.644531 C 37.34375 34.355469 37.328125 32.058594 37.34375 29.753906 C 36.570312 29.769531 35.804688 29.753906 35.042969 29.703125 Z M 35.042969 29.703125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(52.156863%,0.784314%,43.529412%)",
      fillOpacity: 1
    },
    d: "M 39.738281 27.359375 C 40.507812 27.359375 41.273438 27.359375 42.039062 27.359375 C 42.039062 29.6875 42.039062 32.019531 42.039062 34.347656 C 41.257812 34.347656 40.472656 34.347656 39.691406 34.347656 C 39.691406 33.582031 39.691406 32.816406 39.691406 32.050781 C 40.457031 32.050781 41.226562 32.050781 41.992188 32.050781 C 41.992188 30.503906 41.992188 28.953125 41.992188 27.40625 C 41.234375 27.421875 40.480469 27.40625 39.738281 27.359375 Z M 39.738281 27.359375 "
  }), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface20",
    mask: "url(#mask5)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(31.372549%,0.392157%,26.27451%)",
      fillOpacity: 1
    },
    d: "M 21.054688 29.703125 C 21.101562 30.460938 21.121094 31.226562 21.105469 32.003906 C 23.417969 32.003906 25.734375 32.003906 28.050781 32.003906 C 25.726562 32.050781 23.394531 32.066406 21.054688 32.050781 C 21.054688 31.269531 21.054688 30.488281 21.054688 29.703125 Z M 21.054688 29.703125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(40.784314%,0.784314%,35.686275%)",
      fillOpacity: 1
    },
    d: "M 28.050781 34.347656 C 28.050781 34.363281 28.050781 34.378906 28.050781 34.394531 C 25.734375 34.394531 23.417969 34.394531 21.105469 34.394531 C 21.105469 35.164062 21.105469 35.929688 21.105469 36.695312 C 21.085938 36.695312 21.070312 36.695312 21.054688 36.695312 C 21.054688 35.914062 21.054688 35.128906 21.054688 34.347656 C 23.386719 34.347656 25.71875 34.347656 28.050781 34.347656 Z M 28.050781 34.347656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(39.607843%,0.392157%,34.509804%)",
      fillOpacity: 1
    },
    d: "M 44.386719 34.394531 C 46.710938 34.347656 49.042969 34.332031 51.382812 34.347656 C 51.382812 35.128906 51.382812 35.914062 51.382812 36.695312 C 51.332031 35.9375 51.316406 35.171875 51.332031 34.394531 C 49.785156 34.394531 48.234375 34.394531 46.6875 34.394531 C 45.921875 34.394531 45.152344 34.394531 44.386719 34.394531 Z M 44.386719 34.394531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(67.45098%,1.176471%,58.823529%)",
      fillOpacity: 1
    },
    d: "M 28.050781 34.394531 C 28.050781 35.164062 28.050781 35.929688 28.050781 36.695312 C 28.808594 36.742188 29.574219 36.757812 30.351562 36.742188 C 30.351562 39.039062 30.351562 41.335938 30.351562 43.636719 C 29.574219 43.621094 28.808594 43.636719 28.050781 43.683594 C 27.285156 43.683594 26.515625 43.683594 25.75 43.683594 C 25.75 42.121094 25.75 40.554688 25.75 38.992188 C 24.96875 38.992188 24.1875 38.992188 23.402344 38.992188 C 23.402344 38.226562 23.402344 37.460938 23.402344 36.695312 C 22.636719 36.695312 21.871094 36.695312 21.105469 36.695312 C 21.105469 35.929688 21.105469 35.164062 21.105469 34.394531 C 23.417969 34.394531 25.734375 34.394531 28.050781 34.394531 Z M 28.050781 34.394531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(27.843137%,0.784314%,23.921569%)",
      fillOpacity: 1
    },
    d: "M 39.691406 34.347656 C 40.472656 34.347656 41.257812 34.347656 42.039062 34.347656 C 41.28125 34.394531 40.515625 34.410156 39.738281 34.394531 C 39.753906 35.171875 39.738281 35.9375 39.691406 36.695312 C 39.691406 35.914062 39.691406 35.128906 39.691406 34.347656 Z M 39.691406 34.347656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(52.156863%,0.392157%,43.529412%)",
      fillOpacity: 1
    },
    d: "M 44.386719 34.394531 C 45.152344 34.394531 45.921875 34.394531 46.6875 34.394531 C 46.6875 35.164062 46.6875 35.929688 46.6875 36.695312 C 47.46875 36.695312 48.25 36.695312 49.035156 36.695312 C 49.035156 39.023438 49.035156 41.355469 49.035156 43.683594 C 49.800781 43.683594 50.566406 43.683594 51.332031 43.683594 C 51.332031 44.449219 51.332031 45.214844 51.332031 45.980469 C 49.800781 45.980469 48.265625 45.980469 46.734375 45.980469 C 46.6875 45.222656 46.671875 44.457031 46.6875 43.683594 C 45.921875 43.683594 45.152344 43.683594 44.386719 43.683594 C 44.386719 42.902344 44.386719 42.121094 44.386719 41.335938 C 43.621094 41.335938 42.855469 41.335938 42.085938 41.335938 C 42.085938 39.804688 42.085938 38.273438 42.085938 36.742188 C 42.863281 36.757812 43.628906 36.742188 44.386719 36.695312 C 44.386719 35.929688 44.386719 35.164062 44.386719 34.394531 Z M 44.386719 34.394531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(67.45098%,1.176471%,58.823529%)",
      fillOpacity: 1
    },
    d: "M 46.6875 34.394531 C 48.234375 34.394531 49.785156 34.394531 51.332031 34.394531 C 51.316406 35.171875 51.332031 35.9375 51.382812 36.695312 C 52.148438 36.695312 52.914062 36.695312 53.679688 36.695312 C 53.679688 39.023438 53.679688 41.355469 53.679688 43.683594 C 52.914062 43.683594 52.148438 43.683594 51.382812 43.683594 C 51.367188 43.683594 51.347656 43.683594 51.332031 43.683594 C 50.566406 43.683594 49.800781 43.683594 49.035156 43.683594 C 49.035156 41.355469 49.035156 39.023438 49.035156 36.695312 C 48.25 36.695312 47.46875 36.695312 46.6875 36.695312 C 46.6875 35.929688 46.6875 35.164062 46.6875 34.394531 Z M 46.6875 34.394531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(52.156863%,0.392157%,43.921569%)",
      fillOpacity: 1
    },
    d: "M 21.054688 36.695312 C 21.070312 36.695312 21.085938 36.695312 21.105469 36.695312 C 21.871094 36.695312 22.636719 36.695312 23.402344 36.695312 C 23.402344 37.460938 23.402344 38.226562 23.402344 38.992188 C 24.1875 38.992188 24.96875 38.992188 25.75 38.992188 C 25.75 40.554688 25.75 42.121094 25.75 43.683594 C 26.515625 43.683594 27.285156 43.683594 28.050781 43.683594 C 28.050781 44.449219 28.050781 45.214844 28.050781 45.980469 C 25.734375 45.980469 23.417969 45.980469 21.105469 45.980469 C 21.121094 45.207031 21.101562 44.441406 21.054688 43.683594 C 20.289062 43.683594 19.523438 43.683594 18.757812 43.683594 C 18.757812 41.355469 18.757812 39.023438 18.757812 36.695312 C 19.523438 36.695312 20.289062 36.695312 21.054688 36.695312 Z M 21.054688 36.695312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(51.764706%,0.784314%,45.490196%)",
      fillOpacity: 1
    },
    d: "M 28.050781 36.695312 C 28.832031 36.695312 29.617188 36.695312 30.398438 36.695312 C 30.398438 39.023438 30.398438 41.355469 30.398438 43.683594 C 29.617188 43.683594 28.832031 43.683594 28.050781 43.683594 C 28.808594 43.636719 29.574219 43.621094 30.351562 43.636719 C 30.351562 41.335938 30.351562 39.039062 30.351562 36.742188 C 29.574219 36.757812 28.808594 36.742188 28.050781 36.695312 Z M 28.050781 36.695312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(40%,0.392157%,32.941176%)",
      fillOpacity: 1
    },
    d: "M 44.386719 36.695312 C 43.628906 36.742188 42.863281 36.757812 42.085938 36.742188 C 42.085938 38.273438 42.085938 39.804688 42.085938 41.335938 C 42.070312 41.335938 42.054688 41.335938 42.039062 41.335938 C 42.039062 39.789062 42.039062 38.242188 42.039062 36.695312 C 42.820312 36.695312 43.605469 36.695312 44.386719 36.695312 Z M 44.386719 36.695312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(51.764706%,0.392157%,43.137255%)",
      fillOpacity: 1
    },
    d: "M 35.042969 41.335938 C 34.261719 41.335938 33.480469 41.335938 32.699219 41.335938 C 32.699219 40.570312 32.699219 39.804688 32.699219 39.039062 C 33.480469 39.039062 34.261719 39.039062 35.042969 39.039062 C 35.042969 39.804688 35.042969 40.570312 35.042969 41.335938 Z M 35.042969 41.335938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(50.588235%,0.784314%,44.313725%)",
      fillOpacity: 1
    },
    d: "M 35.042969 41.335938 C 37.375 41.335938 39.707031 41.335938 42.039062 41.335938 C 42.039062 42.121094 42.039062 42.902344 42.039062 43.683594 C 41.992188 42.925781 41.976562 42.160156 41.992188 41.386719 C 39.691406 41.386719 37.390625 41.386719 35.09375 41.386719 C 35.109375 42.160156 35.09375 42.925781 35.042969 43.683594 C 35.042969 42.902344 35.042969 42.121094 35.042969 41.335938 Z M 35.042969 41.335938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(67.45098%,1.176471%,58.823529%)",
      fillOpacity: 1
    },
    d: "M 42.039062 43.683594 C 42.796875 43.730469 43.5625 43.746094 44.339844 43.730469 C 44.339844 46.027344 44.339844 48.328125 44.339844 50.625 C 43.574219 50.625 42.804688 50.625 42.039062 50.625 C 41.273438 50.625 40.507812 50.625 39.738281 50.625 C 39.738281 49.078125 39.738281 47.527344 39.738281 45.980469 C 38.175781 45.980469 36.609375 45.980469 35.042969 45.980469 C 35.042969 45.214844 35.042969 44.449219 35.042969 43.683594 C 35.09375 42.925781 35.109375 42.160156 35.09375 41.386719 C 37.390625 41.386719 39.691406 41.386719 41.992188 41.386719 C 41.976562 42.160156 41.992188 42.925781 42.039062 43.683594 Z M 42.039062 43.683594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(11.764706%,0%,9.411765%)",
      fillOpacity: 1
    },
    d: "M 42.039062 41.335938 C 42.054688 41.335938 42.070312 41.335938 42.085938 41.335938 C 42.855469 41.335938 43.621094 41.335938 44.386719 41.335938 C 44.386719 42.121094 44.386719 42.902344 44.386719 43.683594 C 43.605469 43.683594 42.820312 43.683594 42.039062 43.683594 C 42.039062 42.902344 42.039062 42.121094 42.039062 41.335938 Z M 42.039062 41.335938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 42.085938 41.386719 C 42.839844 41.386719 43.589844 41.386719 44.339844 41.386719 C 44.339844 42.136719 44.339844 42.886719 44.339844 43.636719 C 43.589844 43.636719 42.839844 43.636719 42.085938 43.636719 C 42.085938 42.886719 42.085938 42.136719 42.085938 41.386719 Z M 42.085938 41.386719 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(27.058824%,0.392157%,22.745098%)",
      fillOpacity: 1
    },
    d: "M 32.746094 43.683594 C 32.746094 45.996094 32.746094 48.3125 32.746094 50.625 C 33.519531 50.609375 34.285156 50.625 35.042969 50.671875 C 34.277344 50.671875 33.511719 50.671875 32.746094 50.671875 C 32.746094 51.4375 32.746094 52.203125 32.746094 52.972656 C 32.699219 52.214844 32.679688 51.449219 32.699219 50.671875 C 31.929688 50.671875 31.164062 50.671875 30.398438 50.671875 C 30.398438 50.65625 30.398438 50.640625 30.398438 50.625 C 31.164062 50.625 31.929688 50.625 32.699219 50.625 C 32.679688 48.304688 32.699219 45.988281 32.746094 43.683594 Z M 32.746094 43.683594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(52.156863%,0.392157%,43.529412%)",
      fillOpacity: 1
    },
    d: "M 32.746094 43.683594 C 33.511719 43.683594 34.277344 43.683594 35.042969 43.683594 C 35.042969 44.449219 35.042969 45.214844 35.042969 45.980469 C 36.585938 46.027344 38.132812 46.046875 39.691406 46.027344 C 39.691406 47.578125 39.691406 49.125 39.691406 50.671875 C 40.457031 50.671875 41.226562 50.671875 41.992188 50.671875 C 41.992188 51.421875 41.992188 52.171875 41.992188 52.921875 C 39.691406 52.921875 37.390625 52.921875 35.09375 52.921875 C 35.109375 52.164062 35.09375 51.414062 35.042969 50.671875 C 34.285156 50.625 33.519531 50.609375 32.746094 50.625 C 32.746094 48.3125 32.746094 45.996094 32.746094 43.683594 Z M 32.746094 43.683594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(49.411765%,0.784314%,43.529412%)",
      fillOpacity: 1
    },
    d: "M 42.039062 43.683594 C 42.820312 43.683594 43.605469 43.683594 44.386719 43.683594 C 44.386719 46.011719 44.386719 48.34375 44.386719 50.671875 C 43.605469 50.671875 42.820312 50.671875 42.039062 50.671875 C 42.039062 50.65625 42.039062 50.640625 42.039062 50.625 C 42.804688 50.625 43.574219 50.625 44.339844 50.625 C 44.339844 48.328125 44.339844 46.027344 44.339844 43.730469 C 43.5625 43.746094 42.796875 43.730469 42.039062 43.683594 Z M 42.039062 43.683594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(22.745098%,0.392157%,18.823529%)",
      fillOpacity: 1
    },
    d: "M 21.054688 43.683594 C 21.101562 44.441406 21.121094 45.207031 21.105469 45.980469 C 23.417969 45.980469 25.734375 45.980469 28.050781 45.980469 C 28.050781 45.996094 28.050781 46.011719 28.050781 46.027344 C 25.71875 46.027344 23.386719 46.027344 21.054688 46.027344 C 21.054688 45.246094 21.054688 44.464844 21.054688 43.683594 Z M 21.054688 43.683594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(23.921569%,0.392157%,19.607843%)",
      fillOpacity: 1
    },
    d: "M 51.332031 43.683594 C 51.347656 43.683594 51.367188 43.683594 51.382812 43.683594 C 51.382812 44.464844 51.382812 45.246094 51.382812 46.027344 C 49.824219 46.046875 48.273438 46.027344 46.734375 45.980469 C 48.265625 45.980469 49.800781 45.980469 51.332031 45.980469 C 51.332031 45.214844 51.332031 44.449219 51.332031 43.683594 Z M 51.332031 43.683594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(60%,0.784314%,51.372549%)",
      fillOpacity: 1
    },
    d: "M 35.042969 45.980469 C 36.609375 45.980469 38.175781 45.980469 39.738281 45.980469 C 39.738281 47.527344 39.738281 49.078125 39.738281 50.625 C 40.507812 50.625 41.273438 50.625 42.039062 50.625 C 42.039062 50.640625 42.039062 50.65625 42.039062 50.671875 C 42.023438 50.671875 42.007812 50.671875 41.992188 50.671875 C 41.226562 50.671875 40.457031 50.671875 39.691406 50.671875 C 39.691406 49.125 39.691406 47.578125 39.691406 46.027344 C 38.132812 46.046875 36.585938 46.027344 35.042969 45.980469 Z M 35.042969 45.980469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(67.45098%,1.176471%,58.823529%)",
      fillOpacity: 1
    },
    d: "M 30.398438 50.671875 C 31.164062 50.671875 31.929688 50.671875 32.699219 50.671875 C 32.679688 51.449219 32.699219 52.214844 32.746094 52.972656 C 33.511719 52.972656 34.277344 52.972656 35.042969 52.972656 C 35.042969 54.519531 35.042969 56.066406 35.042969 57.613281 C 34.277344 57.613281 33.511719 57.613281 32.746094 57.613281 C 31.960938 57.613281 31.179688 57.613281 30.398438 57.613281 C 30.398438 56.066406 30.398438 54.519531 30.398438 52.972656 C 29.632812 52.972656 28.863281 52.972656 28.097656 52.972656 C 28.097656 51.421875 28.097656 49.875 28.097656 48.328125 C 28.097656 47.5625 28.097656 46.796875 28.097656 46.027344 C 28.847656 46.027344 29.597656 46.027344 30.351562 46.027344 C 30.332031 47.585938 30.351562 49.132812 30.398438 50.671875 Z M 30.398438 50.671875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(47.058824%,0.784314%,41.176471%)",
      fillOpacity: 1
    },
    d: "M 28.050781 45.980469 C 28.832031 45.980469 29.617188 45.980469 30.398438 45.980469 C 30.398438 47.527344 30.398438 49.078125 30.398438 50.625 C 30.398438 50.640625 30.398438 50.65625 30.398438 50.671875 C 30.351562 49.132812 30.332031 47.585938 30.351562 46.027344 C 29.597656 46.027344 28.847656 46.027344 28.097656 46.027344 C 28.097656 46.796875 28.097656 47.5625 28.097656 48.328125 C 28.082031 48.328125 28.066406 48.328125 28.050781 48.328125 C 28.050781 47.5625 28.050781 46.796875 28.050781 46.027344 C 28.050781 46.011719 28.050781 45.996094 28.050781 45.980469 Z M 28.050781 45.980469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(52.156863%,0.392157%,43.529412%)",
      fillOpacity: 1
    },
    d: "M 28.050781 48.328125 C 28.050781 49.890625 28.050781 51.453125 28.050781 53.019531 C 28.816406 53.019531 29.582031 53.019531 30.351562 53.019531 C 30.351562 54.566406 30.351562 56.113281 30.351562 57.664062 C 31.132812 57.664062 31.914062 57.664062 32.699219 57.664062 C 32.699219 58.429688 32.699219 59.195312 32.699219 59.960938 C 30.382812 59.960938 28.066406 59.960938 25.75 59.960938 C 25.75 59.179688 25.75 58.394531 25.75 57.613281 C 24.984375 57.613281 24.21875 57.613281 23.449219 57.613281 C 23.449219 55.300781 23.449219 52.988281 23.449219 50.671875 C 24.21875 50.671875 24.984375 50.671875 25.75 50.671875 C 25.75 49.90625 25.75 49.140625 25.75 48.375 C 26.507812 48.328125 27.273438 48.3125 28.050781 48.328125 Z M 28.050781 48.328125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.647059%,0.392157%,14.117647%)",
      fillOpacity: 1
    },
    d: "M 25.75 48.375 C 25.75 49.140625 25.75 49.90625 25.75 50.671875 C 24.984375 50.671875 24.21875 50.671875 23.449219 50.671875 C 23.433594 50.671875 23.417969 50.671875 23.402344 50.671875 C 24.160156 50.625 24.929688 50.609375 25.703125 50.625 C 25.6875 49.867188 25.703125 49.117188 25.75 48.375 Z M 25.75 48.375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(28.235294%,0.392157%,23.529412%)",
      fillOpacity: 1
    },
    d: "M 23.402344 50.671875 C 23.417969 50.671875 23.433594 50.671875 23.449219 50.671875 C 23.449219 52.988281 23.449219 55.300781 23.449219 57.613281 C 24.21875 57.613281 24.984375 57.613281 25.75 57.613281 C 25.75 58.394531 25.75 59.179688 25.75 59.960938 C 25.703125 59.203125 25.6875 58.4375 25.703125 57.664062 C 24.9375 57.664062 24.167969 57.664062 23.402344 57.664062 C 23.402344 55.332031 23.402344 53.003906 23.402344 50.671875 Z M 23.402344 50.671875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 35.042969 50.671875 C 35.042969 51.4375 35.042969 52.203125 35.042969 52.972656 C 34.277344 52.972656 33.511719 52.972656 32.746094 52.972656 C 32.746094 52.203125 32.746094 51.4375 32.746094 50.671875 C 33.511719 50.671875 34.277344 50.671875 35.042969 50.671875 Z M 35.042969 50.671875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(43.529412%,0.392157%,36.078431%)",
      fillOpacity: 1
    },
    d: "M 35.042969 50.671875 C 35.09375 51.414062 35.109375 52.164062 35.09375 52.921875 C 37.390625 52.921875 39.691406 52.921875 41.992188 52.921875 C 41.992188 52.171875 41.992188 51.421875 41.992188 50.671875 C 42.007812 50.671875 42.023438 50.671875 42.039062 50.671875 C 42.039062 51.4375 42.039062 52.203125 42.039062 52.972656 C 39.707031 52.972656 37.375 52.972656 35.042969 52.972656 C 35.042969 52.203125 35.042969 51.4375 35.042969 50.671875 Z M 35.042969 50.671875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(19.215686%,0.784314%,15.686275%)",
      fillOpacity: 1
    },
    d: "M 35.042969 52.972656 C 37.375 52.972656 39.707031 52.972656 42.039062 52.972656 C 39.730469 53.019531 37.417969 53.035156 35.09375 53.019531 C 35.09375 54.566406 35.09375 56.113281 35.09375 57.664062 C 34.308594 57.664062 33.527344 57.664062 32.746094 57.664062 C 32.746094 57.644531 32.746094 57.628906 32.746094 57.613281 C 33.511719 57.613281 34.277344 57.613281 35.042969 57.613281 C 35.042969 56.066406 35.042969 54.519531 35.042969 52.972656 Z M 35.042969 52.972656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(58.431373%,0.784314%,49.803922%)",
      fillOpacity: 1
    },
    d: "M 28.050781 48.328125 C 28.066406 48.328125 28.082031 48.328125 28.097656 48.328125 C 28.097656 49.875 28.097656 51.421875 28.097656 52.972656 C 28.863281 52.972656 29.632812 52.972656 30.398438 52.972656 C 30.398438 54.519531 30.398438 56.066406 30.398438 57.613281 C 31.179688 57.613281 31.960938 57.613281 32.746094 57.613281 C 32.746094 57.628906 32.746094 57.644531 32.746094 57.664062 C 32.730469 57.664062 32.714844 57.664062 32.699219 57.664062 C 31.914062 57.664062 31.132812 57.664062 30.351562 57.664062 C 30.351562 56.113281 30.351562 54.566406 30.351562 53.019531 C 29.582031 53.019531 28.816406 53.019531 28.050781 53.019531 C 28.050781 51.453125 28.050781 49.890625 28.050781 48.328125 Z M 28.050781 48.328125 "
  }), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface23",
    mask: "url(#mask6)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(13.333333%,1.176471%,10.588235%)",
      fillOpacity: 1
    },
    d: "M 32.699219 57.664062 C 32.714844 57.664062 32.730469 57.664062 32.746094 57.664062 C 32.746094 58.445312 32.746094 59.226562 32.746094 60.007812 C 30.40625 60.023438 28.074219 60.007812 25.75 59.960938 C 28.066406 59.960938 30.382812 59.960938 32.699219 59.960938 C 32.699219 59.195312 32.699219 58.429688 32.699219 57.664062 Z M 32.699219 57.664062 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrape);
export default __webpack_public_path__ + "static/media/grape.5c01ba87e5356dc2c01c853ce964b520.svg";
export { ForwardRef as ReactComponent };